export const getLiveValidationFields = fields =>
  fields.filter(
    field =>
      field !== 'customSlug' && field !== 'bio' && field !== 'facilities',
  )

export const getSaveValidationFields = sections =>
  sections
    .flatMap(section => section.fields || [])
    .filter(field => field !== 'customSlug' && field !== 'facilities')

export const handleEditProfileSave = async ({
  trigger,
  getSaveValidationFields: getFields,
  getValues,
  onSubmit,
  onInvalid,
}) => {
  const isValid = await trigger(getFields())

  if (!isValid) {
    onInvalid()
    return
  }

  onSubmit(getValues())
}
